import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

export interface EkycSessionResult {
  authToken: string
  scanRef: string
  redirectUrl: string | null
  iframeSrc: string
  ekycStatus: string
  ekycAttemptUsed: boolean
}

export function useCreateEkycSession() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<ApiResponse<EkycSessionResult>>(
        '/api/v1/ekyc/sessions',
        {},
      )
      return data.data
    },
    onSuccess: () => {
      Promise.resolve(qc.invalidateQueries({ queryKey: queryKeys.spProfile.detail() })).catch(
        () => undefined,
      )
    },
  })
}

export function useAbandonEkycSession() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<ApiResponse<{
        ekycStatus: string
        ekycAttemptUsed: boolean
        ekycFailureReason: string | null
      }>>('/api/v1/ekyc/sessions/abandon', {})
      return data.data
    },
    onSuccess: () => {
      Promise.resolve(qc.invalidateQueries({ queryKey: queryKeys.spProfile.detail() })).catch(
        () => undefined,
      )
    },
  })
}
